/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { GetUsersPreferencesPipeSeriesOptions, GetUsersPreferencesPipeSeriesResponses } from '../types/GetUsersPreferencesPipeSeries'
import { client, withUnwrap } from '../.kubb/client'

/**
 * {@link /users/preferences/pipe-series/}
 */
export function getUsersPreferencesPipeSeries<ThrowOnError extends boolean = true>(options: Options<GetUsersPreferencesPipeSeriesOptions, ThrowOnError> = {}): Unwrappable<RequestResult<GetUsersPreferencesPipeSeriesResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(request({ method: 'GET', url: '/users/preferences/pipe-series/', security: [{ type: 'http', scheme: 'bearer' }], ...config, throwOnError: config.throwOnError ?? true }) as Promise<RequestResult<GetUsersPreferencesPipeSeriesResponses, ThrowOnError>>)
}
